import { AgGridAngular } from 'ag-grid-angular';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { ChallengedUsersModalComponent } from '../challenged-users-modal/challenged-users-modal.component';
import { ChallengesService } from '../../../services/challenges.service';
import { cloneDeep } from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ExportItems, TypeFormats } from 'src/shared/types/exportItem';
import { GridOptions } from 'ag-grid-enterprise';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChallengeTypes, getChallengeRewardText } from '../../../models/challenge.model';

@Component({
    selector: 'cv-challenges-history',
    templateUrl: './challenges-history.component.html',
    styleUrls: ['./challenges-history.component.scss']
})
export class ChallengesHistoryComponent implements OnInit {
    @ViewChild('challengesHistoryGrid') agGrid: AgGridAngular;

    cs = null;
    search: string = "";
    isLoading: boolean = true;
    sortedData: [];
    ModuleManagerExportFormat = ModuleManagerExportFormat;

    items: ExportItems = {
        excel: {
            getData: (format) => this.onExport(format),
        },
        csv: {
            getData: (format) => this.onExport(format),
        }
    };

    orderBy = {
        key: 'EndDate',
        reversed: true,
    };

    _challenge = {
        Metric: "",
        Rankings: [],
        ChallengeID: undefined,
        EndDate: undefined,
        StartDate: undefined,
        players: [],
        ChallengeType: null,
        shadowBoxing: null,
    };

    historyTable: GridOptions = null;

    constructor(
        private modalService: NgbModal,
        private challengesService: ChallengesService,
        private navigationService: NavigationService,
        private agGridHelperService: AgGridHelperService
    ) {
        this.cs = this.challengesService.data;
    }

    ngOnInit(): void {
        this.setupGrid();
        this.loadHistory();
    }

    setupGrid(): void {
        this.historyTable = this.agGridHelperService.createGridOptions({
            columnDefs: [{
                field: 'EndDate_ForView',
                headerName: this.getLocalizedMessage("Date_Range_Column", "Date Range"),
                width: 120,
                cellRenderer: (param) => { return '<div class="d-flex align-items-center h-100">' + this.dateRenderer(param) + "</div>" }
            }, {
                field: 'Metrics',
                headerName: this.getLocalizedMessage("Metric_Column", "Metric"),
                width: 75,
                cellRenderer: (param) => { return '<div class="d-flex align-items-center h-100">' + param.value + "</div>" }
            }, {
                field: 'Rankings',
                headerName: this.getLocalizedMessage("Winner", "Winner"),
                width: 90,
                filterValueGetter: (params) => {
                  return this.leadRenderer({ value: params.data?.Rankings || []});
                },
                cellRenderer: (param) => { return '<div class="d-flex align-items-center h-100">' + this.leadRenderer(param) + "</div>" }
            }, {
                field: 'Participants',
                headerName: this.getLocalizedMessage("Participants", "Participants"),
                width: 85,
                type: 'numericColumn',
                cellRenderer: (param) => { return '<div class="d-flex align-items-center justify-content-end h-100">' + param.value + "</div>" }
              },
              {
                field: 'ChallengeTypeName',
                headerName: this.getLocalizedMessage("Type", "Type"),
                width: 85,
                cellRenderer: (param) => `<div class="d-flex align-items-center h-100"> ${param.value} </div>`
              },
             {
                field: 'Invitees',
                headerName: this.getLocalizedMessage("Invitees_Column", "Users Invited"),
                width: 85,
                type: 'numericColumn',
                cellRenderer: (param) => { return '<div class="d-flex align-items-center justify-content-end h-100">' + param.value + "</div>" }
            }, {
                field: 'Wager',
                headerName: this.getLocalizedMessage("Wager", "Wager"),
                width: 70,
                cellRenderer: (param) => { return '<div class="d-flex align-items-center h-100">' + param.value + " " + getChallengeRewardText({ challengeType: param.data?.ChallengeType, getLocalizedMessage: this.getLocalizedMessage, quantity: param.value }) + "</div>" }
            }
            ],
            rowData: [],
            rowSelection: 'single',
            accentedSort: true,
            animateRows: true,
            suppressCellFocus: true,
            suppressDragLeaveHidesColumns: true,
            rowHeight: 50,

            isExternalFilterPresent: this.isExternalFilterPresent,
            doesExternalFilterPass: (node) => {
                var tmpFilter = this.search.toUpperCase();

                return (node.data.Metrics && node.data.Metrics.toUpperCase().includes(tmpFilter)
                    || node.data.EndDate_ForView && node.data.EndDate_ForView.toString().includes(tmpFilter)
                    || node.data.StartDate_ForView && node.data.StartDate_ForView.toString().includes(tmpFilter)
                    || node.data.Rankings.length != 0 && node.data.Rankings[0].Name.toUpperCase().includes(tmpFilter)
                    || node.data.Participants && node.data.Participants.toString().includes(tmpFilter)
                    || node.data.Invitees && node.data.Invitees.toString().includes(tmpFilter)
                    || node.data.Wager != 0 && (node.data.Wager + " " + this.getLocalizedMessage("Coins", "Coins").toUpperCase()).includes(tmpFilter))
                    || node.data.ChallengeType && node.data.ChallengeType.toUpperCase().includes(tmpFilter)
            },
            getLocaleText: this.agGridHelperService.getLocaleText,

            components: {
                groupRenderer: this.agGridHelperService.GroupDrillDownCellRenderer,
            },

            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                menuTabs: ['filterMenuTab', 'generalMenuTab'],
            },
            onGridSizeChanged: (e) => {
                e.api.sizeColumnsToFit();
            },
            getRowId: ({data: rowData}) => rowData.ChallengeID,
            onRowClicked: (params) => {
                this._challenge.Metric = params.data.Metrics;
                this._challenge.Rankings = params.data.Rankings;
                this._challenge.ChallengeID = params.data.ChallengeID;
                this._challenge.StartDate = params.data.StartDate;
                this._challenge.EndDate = params.data.EndDate;
                this._challenge.players = params.data.BbPlayers;
                this._challenge.ChallengeType = params.data.ChallengeType;
                this._challenge.shadowBoxing = params.data.shadowBoxing;

                this.loadModal(this._challenge);
            },
            postSortRows: (X) => {
                let selectedRowNodesWithSort = [];
                this.agGrid?.api.forEachNodeAfterFilterAndSort((node) => {
                    selectedRowNodesWithSort.push(node.data);
                });
                this.sortedData = cloneDeep(selectedRowNodesWithSort);
            },
        });
    }

    get disabled() {
      return !this.cs || !this.cs.history || this.cs.history.length === 0;
    }

    loadHistory() {
        this.challengesService.loadChallengesHistory().then((response) => {
            this.isLoading = false;

            if (this.agGrid?.api)
                this.agGrid?.api.setGridOption('rowData', this.cs.history);
            else
                this.agGrid.rowData = this.cs.history;
        });
    }

    loadModal(object) {
        this.navigationService.showOverlay = true;
        var modalInstance = this.modalService.open(ChallengedUsersModalComponent, {
            animation: true,
            backdropClass: 'stopScrolling',
            size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered',
        });

        modalInstance.componentInstance.challengeObj = object;

        modalInstance.result.finally(() => {
            this.navigationService.showOverlay = false;
        });
    }

    //CELL RENDERER FUNCTIONS 
    dateRenderer(param) {
        if (param.data.StartDate_ForView == param.value)
            return '<div style="cursor: pointer;"><span class="color-cerulean">' + param.value + '</span></div>';
        else
            return '<div style="cursor: pointer;"><span class="color-cerulean">' + param.data.StartDate_ForView + " - " + param.value + '</span></div>';
    }

    leadRenderer(param) {
        if (param.value != undefined && param.value != null && param.value.length != 0) {
            if([ChallengeTypes.BattleBoat, ChallengeTypes.ShadowBoxing].includes(param?.data?.ChallengeType)) {
              const winner = param.value.find(p => p.Place == 1); // there will be just one winner for battle boat challenge
              return winner?.Name || this.getLocalizedMessage('None', 'None');
            }
            return param.value[0].Name;
        }
    }

    //DATA FILTERING FUNCTIONS
    filterChanged(): void {
        setTimeout(() => {
            this.agGrid?.api.onFilterChanged();
        }, 0);
    }

    clearFilter(): void {
        this.search = '';
        this.agGrid?.api.onFilterChanged();
    }

    isExternalFilterPresent() {
        return true;
    }

    getLocalizedMessage = (key: string, fallback: string): string => {
        if (this.cs && this.cs.localizedStrings && this.cs.localizedStrings.has(key)) {
            return this.cs.localizedStrings.get(key);
        }
        else { return fallback; }
    }

    async onExport(format: TypeFormats) {
        const columnsState = this.agGrid?.api.getColumnState();
        const result = await this.challengesService.getHistoryChanllengeExportFile(format, JSON.stringify({ historyChallengeGridData: this.sortedData, columnStates: columnsState, searchValue: this.search }));
        return result.data;
    }
}